interface LabelBadgeProps {
    type: 'required' | 'optional';
}

export default function LabelBadge({ type }: LabelBadgeProps) {
    const label = type === 'required' ? '必須' : '任意';
    const bgColor = type === 'required' ? 'bg-color-required' : 'bg-gray-500';

    return (
        <div
            className={`flex items-center font-corp font-medium text-color-white-base text-xs rounded-xl px-3 h-4 whitespace-nowrap ml-2 ${bgColor}`}
        >
            {label}
        </div>
    );
}
